// CustomerRow.jsx
import React, { useState } from 'react';
import Classes from './Invoices.module.css';

import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';

export default function TableRow({ value, index }) {

  return (
    <>
      <div
        className={`${Classes.customerRow} ${value.status === 'disabled' ? Classes.disabledRow : ''
          }`}
        key={index}
      >
        <div className={`${Classes.customerInfo} ${Classes.col1}`}>
          <h5>{index+1}</h5>
        </div>

        <div className={`${Classes.bookings} ${Classes.col2}`}>
          <h5>{value.Invoice}</h5>
        </div>

        <div className={`${Classes.dateJoined} ${Classes.col3}`}>
          <h5> {value.Date} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col4}`}>
          <h5> {value.DateDue} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col5}`}>
          <h5> {value.Total} </h5>
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col6}`}>
          <DropDown
            selectedValue={value.Status}
            options={["Paid", "Overdue"]}
            onChange={(val) => value.Status = val}
            isDropDown={false}
          />
        </div>

        <div className={`${Classes.disableToggle} ${Classes.col7}`}>
          {/* <h5> {value.number} </h5> */}
        </div>

        <div className={`${Classes.actions} ${Classes.col8}`}>
          <MoreDropDown
            index={index}
            user={value}
          />
        </div>
      </div>
    </>
  );
}


